import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { FormsModule } from '@angular/forms';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { BusinessModuleService } from 'src/app/services/business-module/business-module.service';
import { filter } from 'rxjs';
import { AnswerService } from 'src/app/services/answer/answer.service';
import { BusinessModuleModel, SectionModel, ControlMeasureModel } from 'src/app/models/models';
import { ControlMeasureService } from 'src/app/services/control-measure/control-measure.service';
import { ValidationService } from 'src/app/services/validation/validation.service';
import { SpinnerService } from 'src/app/services/spinner/spinner.service';
import { SelectedBusinessModuleControlMeasureModel } from 'src/app/models/controlMeasure.model';
import { BreadcrumbsService } from 'src/app/services/breadcrumbs/breadcrumbs.service';
import { Title } from '@angular/platform-browser';

declare function scrollToError(): void

@Component({
  selector: 'app-hazard-step2',
  standalone: true,
  imports: [CommonModule, TranslateModule, FormsModule],
  templateUrl: './hazard-step2.component.html',
  styleUrls: ['./hazard-step2.component.scss']
})
export class HazardStep2Component {
  returnId: string = "";
  businessModule: BusinessModuleModel = {
    id: '',
    completed: false,
    dismissed: false,
    lastUpdatedBy: '',
    lastUpdatedOn: '',
    answers: [],
    module: {
      id: '',
      name: '',
      nameFR: '',
      summary: '',
      summaryFR: '',
      type: '',
      priority: 0,
      imageURL: '',
      dismissible: true
    },
    completedSectionsCount: 0
  };
  section: SectionModel = {
    id: '',
    summary: '',
    summaryFR: '',
    priority: 0,
    type: '',
    moduleId: '',
  };
  ownControlMeasuresTooLong: boolean = false;
  xssCheckFailed: boolean = false;
  controlEmptyError: boolean = false;
  validationFailed: boolean = false;
  hazardId: string = '';
  controlMeasures: ControlMeasureModel[] = [];
  selectedControlMeasuresIds: SelectedBusinessModuleControlMeasureModel[] = [];
  controlMeasureItems: ControlMeasureModel[][] = [];
  ownControlMeasures: {value: string, validationFailed: boolean}[] = [{ value: '', validationFailed: false }];
  elementItemText!: HTMLElement;


  constructor(private titleService: Title,private breadcrumbsService: BreadcrumbsService,public translate: TranslateService, private activatedRoute: ActivatedRoute, private businessModuleService: BusinessModuleService, private router: Router, private answerService: AnswerService, private controlMeasureService: ControlMeasureService, private spinnerService: SpinnerService, private validationService: ValidationService) { 
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe(() => {
      this.ownControlMeasures = [{ value: '', validationFailed: false }];
      const focusedElement = document.activeElement as HTMLElement;
      focusedElement.blur();
    });
  }

  ngOnInit(): void {
    this.activatedRoute.params.subscribe(params => {
      this.hazardId = params['id'];
      this.businessModuleService.getModule(this.hazardId).subscribe(businessModule => {
        this.businessModule = businessModule;

        const hazardLabel =
      this.translate.currentLang === 'en'
        ? businessModule.module.name
        : businessModule.module.nameFR;

   const flowLabel = this.translate.instant('HazardTemplate.HazardFlow');   
   const controlLabel = this.translate.instant('HazardTemplate.Control');
   const fullTitle = `${flowLabel} - ${hazardLabel} - ${controlLabel}`;     
   //this.breadcrumbsService.setLastBreadcrumbLabel(fullTitle);
   this.titleService.setTitle(`WSPB - ${fullTitle}`);

        this.controlMeasureService.getControlMeasure(businessModule.module.id).subscribe(cm => {
          this.controlMeasures = cm.sort((a, b) => a.priority - b.priority);
          this.controlMeasureService.getSelectedControlMeasures(businessModule.id).subscribe(bmCm => {
            for(const item of bmCm){
              this.onCheckboxChange(item.controlMeasureID,item.state);
            }
            let controlMeasure: ControlMeasureModel[] = [];
            for(const item of this.controlMeasures){
              const data = bmCm.find(bm=>bm.controlMeasureID == item.id)
              if(data){
                const selectedControlMeasures = new ControlMeasureModel(item.id,item.moduleId,item.answerText, item.answerTextFR,item.priority, data.state, item.group);
                controlMeasure.push(selectedControlMeasures)
              }else{
                const selectedControlMeasures = new ControlMeasureModel(item.id,item.moduleId,item.answerText, item.answerTextFR,item.priority, "", item.group);
                controlMeasure.push(selectedControlMeasures)
              }
            }
            this.controlMeasureItems[0] = controlMeasure.filter(x => x.group == "EliminationAndSubstitution");
            this.controlMeasureItems[1] = controlMeasure.filter(x => x.group == "EngineeringControls");
            this.controlMeasureItems[2] = controlMeasure.filter(x => x.group == "AdministrativeControls");
            this.controlMeasureItems[3] = controlMeasure.filter(x => x.group == "HygieneFacilitiesAndPractices");
            this.controlMeasureItems[4] = controlMeasure.filter(x => x.group == "PersonalProtectiveEquipment");
            this.controlMeasureItems[5] = controlMeasure.filter(x => x.group == null);
          });
        });
        this.businessModuleService.getSection(this.hazardId, "2").subscribe(section => {
          this.section = section;
          this.answerService.getAnswers(section.id, businessModule.id).subscribe(data => {
            if (data.length != 0) {
              this.ownControlMeasures = [];
              for (const questionAnswer of data){
                this.ownControlMeasures.push({ value: questionAnswer.answerText, validationFailed: false });
              }
            }
          })
        })
      });
    });
    this.activatedRoute.queryParams.subscribe(params => {
      if (params['return'] != undefined)
        this.returnId = params['return'];
    });
  }
  
  addAnswer() {
      this.ownControlMeasures.push({ value: '', validationFailed: false });
  }

  removeAnswer(index: number) {
      this.ownControlMeasures.splice(index, 1);
  }

  onCheckboxChange(controlMeasureId: string, state: string) {
    this.selectedControlMeasuresIds = this.selectedControlMeasuresIds.filter(i=>i.controlMeasureID != controlMeasureId);
    const selectedControl = new SelectedBusinessModuleControlMeasureModel(this.businessModule.id, controlMeasureId, state);
    this.selectedControlMeasuresIds.push(selectedControl)
  }

  saveAndContinue() {
    let questionAnswer: {answerText: string, questionId: number, answerOrder: number}[] = [];
    this.ownControlMeasuresTooLong = false;
    this.validationFailed = false;
    this.controlEmptyError = false;
    this.xssCheckFailed = false;
    
    if (this.selectedControlMeasuresIds.length < 1)
      this.controlEmptyError = true;
    
    for (const answer of this.ownControlMeasures) {
      answer.validationFailed = false;
      if (answer.value.trim() !== '') {
        if (answer.value.trim().length > 80) {
          answer.validationFailed = true;
          this.ownControlMeasuresTooLong = true;
        } else if (!this.validationService.hasPassedXssValidation(answer.value.trim()) && !this.ownControlMeasuresTooLong) {
          this.xssCheckFailed = true;
        }
        questionAnswer.push({
          answerText: answer.value.trim(),
          questionId: 2,
          answerOrder: questionAnswer.length + 1
        });
      }
    }

    if (questionAnswer.length > 0)
      this.controlEmptyError = false;

    if (this.ownControlMeasuresTooLong || this.controlEmptyError || this.xssCheckFailed) {
      this.validationFailed = true;
      scrollToError();
      this.elementItemText = document.getElementById('hidden-text') as HTMLElement;
      if(this.elementItemText){
        this.elementItemText.focus();
      }
    } 
    else {
      for (let i = 0; i < 6; ++i) {
        for(const item of this.controlMeasureItems[i]){
          if(!this.selectedControlMeasuresIds.find(i=>i.controlMeasureID === item.id)){
            const selectedControl = new SelectedBusinessModuleControlMeasureModel(this.businessModule.id, item.id, "notdoing");
            this.selectedControlMeasuresIds.push(selectedControl);
          }
        }
      }
      this.answerService.addAnswers(this.section.id, this.businessModule.id, questionAnswer).subscribe({
        next: () => {
          this.businessModuleService.addCompletedBusinessModuleSection(this.businessModule.id, this.section.id).subscribe(_ => {});
          this.controlMeasureService.changeSelectedControlMeasures(this.businessModule.id, this.selectedControlMeasuresIds).subscribe(_ =>{});
          this.businessModuleService.updateCompleted(this.businessModule.module.id, true).subscribe(() => {
            if(this.returnId != "")
              this.router.navigate(['../../../safetyplans/newplanstep2/', this.returnId], { relativeTo: this.activatedRoute });
            else
              this.router.navigate(['../../', 'summary', this.hazardId], { relativeTo: this.activatedRoute });
          });
      },
      error: (error) => {
        if(error.error?.Message === ValidationService.ServerXssError) {
          this.xssCheckFailed = true;
          this.validationFailed = true;
          scrollToError();
          this.elementItemText = document.getElementById('hidden-text') as HTMLElement;
          if(this.elementItemText){
            this.elementItemText.focus();
          }
        }
        this.spinnerService.hide();
      }
    });
  }
}

  back() {
    if (this.returnId != "")
      this.router.navigate(['../../', 1, this.hazardId], { queryParams: {return: this.returnId}, relativeTo: this.activatedRoute });
    else
      this.router.navigate(['../../', 1, this.hazardId], { relativeTo: this.activatedRoute });
  }

  scrollToHazardAnswer(questionId: string) {
    const element = document.getElementById(questionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  }
}
